var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-lg-12"},[_c('ejs-treeview',{ref:"measureTreeForDataQuery",attrs:{"fields":_vm.fieldsOfMeasureTreeForDataQuery,"showCheckBox":true,"nodeChecked":_vm.measureTreeNodeChecked,"nodeSelected":_vm.measureTreeNodeSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }